"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.HeaderArea = void 0;

require("antd/lib/icon/style");

var _icon = _interopRequireDefault(require("antd/lib/icon"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _Core = require("../../../components/Core");

var _Link = require("../../../react-static/components/Link");

var _mobxReact = require("mobx-react");

var _styled = require("../../../styles/styled");

var _CollapseMenu = require("../../../components/navigation/CollapseMenu");

var _client = require("../../../html/client");

var _class;

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 80px;\n    font-size: 18px;\n    word-wrap: break-word;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: white;\n  display: inline-block;\n  vertical-align: middle;\n  font-size: 26px;\n  margin: 0 0 0 12px;\n  font-family: Work Sans, Arial, sans-serif;\n  font-weight: 500;\n  width: 200px;\n  max-height: 100%;\n  line-height: normal;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SiteTitle = _styled.styled.h1(_templateObject(), _Core.media.screenSm(_templateObject2()));

var FullWidthMenu = (0, _styled.styled)(_CollapseMenu.CollapseMenu)(_templateObject3());

var HeaderArea = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(HeaderArea, _Component);

  function HeaderArea(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = HeaderArea.prototype;

  _proto.render = function render() {
    var siteStore = this.props.siteStore;
    return _react.default.createElement(_Core.Flex, null, (0, _client.isClient)() && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Link.Link, {
      to: siteStore.siteHomeUrl
    }, _react.default.createElement(SiteTitle, null, siteStore.siteDisplayName)), _react.default.createElement(_Core.Flex, {
      pl: 3,
      width: 1,
      justifyContent: "flex-end"
    }, _react.default.createElement(FullWidthMenu, {
      key: "primaryMenu",
      mode: "horizontal",
      theme: "dark",
      overflowedIndicator: _react.default.createElement(_icon.default, {
        type: "menu-unfold"
      })
    }))));
  };

  return HeaderArea;
}(_react.Component)) || _class;

exports.HeaderArea = HeaderArea;